import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#golf-ball-clip0_2638_711)\"><path stroke=\"currentColor\" stroke-width=\".4\" d=\"M21.75 6.907a11 11 0 1 0-19.5 10.187 11 11 0 0 0 19.5-10.187Zm-.785 7.92a9.43 9.43 0 1 1-.644-7.19 9.43 9.43 0 0 1 .675 7.19z\"></path><path d=\"M15.929 16.72a.785.785 0 1 0 0 1.57.785.785 0 0 0 0-1.57M18.286 13.578a.786.786 0 1 0 0 1.57.786.786 0 0 0 0-1.57M15.929 14.363a.785.785 0 1 0-1.571 0 .785.785 0 0 0 1.57 0M18.286 10.435a.786.786 0 1 0 0 1.572.786.786 0 0 0 0-1.572M12.786 17.506a.786.786 0 1 0 0 1.573.786.786 0 0 0 0-1.573\"></path></g><defs><clipPath id=\"golf-ball-clip0_2638_711\"><path fill=\"currentColor\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }